import { SupplyBasicFeaturePage } from "..";

/** 导游供应商页面。 */
export function GuidesPage() {
  return <SupplyBasicFeaturePage kind="guides" />;
}
